import { render, staticRenderFns } from "./NonDocInfo.vue?vue&type=template&id=059fa528"
import script from "./NonDocInfo.vue?vue&type=script&lang=js"
export * from "./NonDocInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports